import { WebPageJsonLd } from "next-seo";
import { addBaseUrl } from "~/modules/app/seo/addBaseUrl";
import type { Manager } from "~/modules/managers";
import { getManagerURL } from "~/routes";

// // // //

export function getManagerPageDescription(props: { manager: Manager }): string {
    const { manager } = props;

    if (manager.description) {
        return manager.description;
    }

    return `View key performance indicators for ${manager.name} in the tokenized real-world asset space.`;
}

// // // //

/**
 * Renders WebPage + Organization JSON-LD structured data
 * for the Asset Manager Individual page.
 */
export function ManagerIndividualSEO(props: { manager: Manager }) {
    const { manager } = props;

    const pageUrl = addBaseUrl(getManagerURL({ managerSlug: manager.slug }));
    const description = getManagerPageDescription({ manager });

    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    const isoYesterday = yesterday.toISOString();

    const organizationJsonLd: Record<string, unknown> = {
        "@context": "https://schema.org",
        "@type": "Organization",
        name: manager.legal_name || manager.name,
        url: manager.website || pageUrl,
        description,
    };

    if (manager.icon_url) {
        organizationJsonLd.logo = manager.icon_url;
    }

    // if (manager.lei) {
    //     organizationJsonLd.identifier = {
    //         "@type": "PropertyValue",
    //         propertyID: "LEI",
    //         value: manager.lei,
    //     };
    // }

    // if (manager.legal_structure_country_name) {
    //     organizationJsonLd.address = {
    //         "@type": "PostalAddress",
    //         addressCountry: manager.legal_structure_country_name,
    //     };
    // }

    return (
        <>
            <WebPageJsonLd
                id={pageUrl}
                description={description}
                lastReviewed={isoYesterday}
                reviewedBy={{
                    type: "Organization",
                    name: "RWA.xyz",
                }}
            />
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{
                    __html: JSON.stringify(organizationJsonLd),
                }}
            />
        </>
    );
}
